
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1308Dialog extends Serenity.EntityDialog<Report_1308Row, any> {
        protected getFormKey() { return Report_1308Form.formKey; }
        protected getIdProperty() { return Report_1308Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1308Row.localTextPrefix; }
        protected getNameProperty() { return Report_1308Row.nameProperty; }
        protected getService() { return Report_1308Service.baseUrl; }
        protected getDeletePermission() { return Report_1308Row.deletePermission; }
        protected getInsertPermission() { return Report_1308Row.insertPermission; }
        protected getUpdatePermission() { return Report_1308Row.updatePermission; }

        protected form = new Report_1308Form(this.idPrefix);

    }
}